const labels = {
  km: {
    weekdayHeaderFormat: 'narrow',
    labelPrevDecade: 'ទសវត្សរ៍មុន',
    labelPrevYear: 'ឆ្នាំមុន',
    labelPrevMonth: 'ខែមុន',
    labelCurrentMonth: 'ខែបច្ចុប្បន្ន',
    labelNextMonth: 'ខែក្រោយ',
    labelNextYear: 'ឆ្នាំក្រោយ',
    labelNextDecade: 'ទសវត្សរ៍ក្រោយ',
    labelToday: 'ថ្ងៃនេះ',
    labelSelected: 'កាលបរិច្ឆេទដែលបានជ្រើសរើស',
    labelNoDateSelected: 'មិនបានជ្រើសរើសកាលបរិច្ឆេទ',
    labelCalendar: 'ប្រតិទិន',
    labelNav: 'ការរុករកប្រតិទិន',
    labelHelp: 'ប្រើប្រាស់គ្រាប់ចុចទិសដើម្បីរុករកកាលបរិច្ឆេទ',
    labelNoTimeSelected: 'មិនមានពេលវេលាបានជ្រើសរើស',
    labelCloseButton: 'បិទ',
    labelResetButton: 'កំណត់ឡើងវិញ',
  },
  vi: {
    weekdayHeaderFormat: 'narrow',
    labelPrevDecade: 'Thập kỷ trước',
    labelPrevYear: 'Năm trước',
    labelPrevMonth: 'Tháng trước',
    labelCurrentMonth: 'Tháng hiện tại',
    labelNextMonth: 'Tháng sau',
    labelNextYear: 'Năm sau',
    labelNextDecade: 'Thập kỷ sau',
    labelToday: 'Hôm nay',
    labelSelected: 'Ngày đã chọn',
    labelNoDateSelected: 'Chưa chọn ngày',
    labelCalendar: 'Lịch',
    labelNav: 'Điều hướng lịch',
    labelHelp: 'Sử dụng phím mũi tên để điều hướng các ngày',
    labelNoTimeSelected: 'Chưa chọn giờ',
    labelCloseButton: 'Đóng',
    labelResetButton: 'Đặt lại',
  },
  'zh-cn': {
    weekdayHeaderFormat: 'narrow',
    labelPrevDecade: '过去十年',
    labelPrevYear: '上一年',
    labelPrevMonth: '上个月',
    labelCurrentMonth: '当前月份',
    labelNextMonth: '下个月',
    labelNextYear: '明年',
    labelNextDecade: '下一个十年',
    labelToday: '今天',
    labelSelected: '选定日期',
    labelNoDateSelected: '选择日期',
    labelCalendar: '日历',
    labelNav: '日历导航',
    labelHelp: '使用光标键浏览日期',
    labelNoTimeSelected: '未选择时间',
    labelCloseButton: '关闭',
    labelResetButton: '重置',
  },
};

export default labels;
